import {Component, OnDestroy, OnInit} from '@angular/core';
import {Breadcrumb} from '@app/models/breadcrumb.model';
import {ActivatedRoute, Router} from '@angular/router';
import {BreadcrumbService} from '@app/shared/breadcrumbs/breadcrumbs.service';
import {environment} from '../../../../../../environments/environment';
import {SwalUtils} from '@app/shared/utils/swal.utils';
import {Globals} from '@app/shared/globals/globals';
import { CompanyFeatures } from '@app/models/company-features.model';
import {CompanySetUpStepType} from '@app/models/company/company-set-up-steps/company-set-up-step-type.enum';
import {SetUpStepUtils} from '@app/shared/utils/setupstep.utils';

@Component({
  selector: 'app-admin-integrations-navigation',
  templateUrl: './admin-integrations-navigation.component.html',
  styleUrls: ['./admin-integrations-navigation.component.scss']
})
export class CompanyDashboardIntegrationsComponent implements OnInit, OnDestroy {
  breadcrumb: Breadcrumb;
  eCompanyFeatures = CompanyFeatures;

  constructor(
      private breadcrumbService: BreadcrumbService,
      public route: ActivatedRoute,
      private router: Router,
      public globals: Globals,
      private swalUtils: SwalUtils,
      private setUpStepUtils: SetUpStepUtils
  ) {
    this.breadcrumb = this.breadcrumbService.init(this.route);
  }

  ngOnInit() {
    this.setUpStepUtils.markStepAsComplete(CompanySetUpStepType.VIEW_INTEGRATIONS);
  }

  ngOnDestroy() {
    this.breadcrumbService.remove(this.breadcrumb);
  }

  navigateToIntegration(integrationPath: string) {
    // We don't allow them to navigate to the integration page because going any further would cause errors on a mock environment
    if (!environment.mock.enabled) {
      this.router.navigate([integrationPath], { relativeTo: this.route }).then();
    } else {
      this.swalUtils.displayMockNoOpSwal().then();
    }
  }
}
